// @core/api/endpoints/localization/delete_locale.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/localization';

/**
 * Delete locale
 * Deletes a locale and all its translations. This operation is irreversible.
 */
export async function DeleteLocale(
  locale_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/locales/:locale_id`;
  requestPath = requestPath.replace(':locale_id', encodeURIComponent(locale_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
